"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectLanguagesList = exports.selectCurrentLanguage = exports.selectCurrentLangCode = exports.selectLanguages = exports.selectLanguagesFetchItems = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const values_1 = __importDefault(require("lodash/fp/values"));
const slice_1 = require("./slice");
const selectLanguagesFetchItems = (state) => state.languagesProvider.fetchItems || slice_1.initialState.fetchItems;
exports.selectLanguagesFetchItems = selectLanguagesFetchItems;
const selectLanguages = (state) => state.languagesProvider.languages || slice_1.initialState.languages;
exports.selectLanguages = selectLanguages;
const selectCurrentLangCode = (state) => state.languagesProvider.currentLangCode || slice_1.initialState.currentLangCode;
exports.selectCurrentLangCode = selectCurrentLangCode;
exports.selectCurrentLanguage = (0, toolkit_1.createSelector)([exports.selectCurrentLangCode, exports.selectLanguages], (currentLangCode, languages) => languages[currentLangCode]);
exports.selectLanguagesList = (0, toolkit_1.createSelector)(exports.selectLanguages, (languages) => (0, values_1.default)(languages));
//# sourceMappingURL=selectors.js.map